package com.swetdot.swetgram.protocol.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

object LegalContract {
    const val CURRENT_VERSION = "2026-08-23"
    const val MINIMUM_AGE = 16
}

@Serializable
data class LegalDocuments(
    @SerialName("terms_version") val termsVersion: String,
    @SerialName("privacy_version") val privacyVersion: String,
    @SerialName("terms_url") val termsUrl: String,
    @SerialName("privacy_url") val privacyUrl: String,
    @SerialName("community_guidelines_url") val communityGuidelinesUrl: String,
    @SerialName("account_deletion_url") val accountDeletionUrl: String,
    @SerialName("minimum_age") val minimumAge: Int,
)

@Serializable
data class LegalStatus(
    @SerialName("documents") val documents: LegalDocuments,
    @SerialName("accepted") val accepted: Boolean,
)

@Serializable
data class LegalAcceptanceRequest(
    @SerialName("accepted_terms_version") val acceptedTermsVersion: String,
    @SerialName("accepted_privacy_version") val acceptedPrivacyVersion: String,
    @SerialName("age_confirmed") val ageConfirmed: Boolean,
)

@Serializable
data class AccountDeletionRequest(
    @SerialName("email") val email: String,
)

@Serializable
data class AccountDeletionConfirmRequest(
    @SerialName("token") val token: String,
)
